import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Translation } from '../../interfaces/translations/translation.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomTranslateLoaderService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<any> {
    const id = lang.split('_')[1];
    return this.GetSemsaTranslations(+id);
  }

  /**
   * Gets the the translations for the public pages
   * @param id  the id of the language from the language service
   */
  public GetSemsaTranslations(id: number): Observable<Translation> {
    return this.http.get<Translation>(
      `${environment.apiRoot}/jwtTranslations/semsa/${id}`,
    );
  }
}
